import { Pipe, PipeTransform, Inject } from 'ng-metadata/core';

/**
 * @ngdoc filter
 * @name mwTrustUrl
 * @module mw.components.contentDocuments
 *
 * @param {string} [input] - The url of which you want to ensure it trusted
 * @return {string} - Your url if its been trusted
 *
 * @description
 * `trustUrl` is used to check that if a url is being passed in can be trusted or not
 */

@Pipe({
    name: 'mwTrustUrl'
})
export class TrustUrlPipe implements PipeTransform {
    constructor (@Inject('$sce') private $sce: ng.ISCEService) {}

    transform(input: string): string {
        return this.$sce.trustAsResourceUrl(input);
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/content-documents/shared/trust-url.pipe.ts